import { render, staticRenderFns } from "./RefundOfExcessComissionEarlyPolicyTermination.vue?vue&type=template&id=e84a15b6&"
import script from "./RefundOfExcessComissionEarlyPolicyTermination.vue?vue&type=script&lang=js&"
export * from "./RefundOfExcessComissionEarlyPolicyTermination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports